export const NDT_METHOD_TYPES = [
  { value: 1, label: "Ultrasonic Testing" },
  { value: 2, label: "Radiographic Testing" },
  { value: 3, label: "Magnetic Particle Testing" },
  { value: 4, label: "Liquid Penetrant Testing" },
];

export const emptyNdtMethodRow = (methodType) => ({
  id: null,
  methodType,
  certificateNo: "",
  certificateDate: "",
  validityDate: "",
  ndtLevel: "",
  ndtTechnique: "",
  limitations: "",
  certificateSubject: "",       // free-text "Certification" paragraph
  examinationDate: "",
  generalPercent: "",
  specificPercent: "",
  practicalPercent: "",
  compositeScore: "",
  result: "",
  totalTrainingHours: "",
  previousCertificateNo: "",
  Level: "",
  nearVision: 0,    // 0 = none, 1 = J1, 2 = J2
  colorContrast: 0,  // 0 = none, 1 = Ishihara Plates, 2 = Shades of Grey
  validitySubject: "",
  recertificationProcess: "",
});

// Always returns exactly 4 rows (one per method), filling in whatever was
// actually saved and defaulting the rest — so the UI always has all 4 tabs
// available even before any certificate has been filled in.
export const mergeNdtMethodRows = (savedRows = []) =>
  NDT_METHOD_TYPES.map((m) => {
    const saved = savedRows.find((r) => Number(r.methodType) === m.value);
    return saved ? { ...emptyNdtMethodRow(m.value), ...saved } : emptyNdtMethodRow(m.value);
  });